export default "__VITE_ASSET__62e24d31__"